/**
 * Domain thresholds the console displays, in one place so no screen re-spells one.
 *
 * A percentage with no threshold beside it is not actionable — 0.6 % means nothing until you
 * know where the cliff is — so several surfaces need these numbers, and a second spelling of
 * 0.75 in a second file is how one screen ends up warning at a level the other does not.
 */

/**
 * Stripe closes a platform account whose dispute rate crosses this. Mirrors
 * `backend/modules/gateway/disputes._STRIPE_DISPUTE_CLIFF_PCT` and
 * `settings_policy.STRIPE_DISPUTE_CLIFF_PCT`.
 *
 * The design document (§8): *"Alert the superadmin when any tenant crosses a 0.5% dispute
 * rate. Stripe's own threshold is 0.75%, at which point the platform account is at risk —
 * one bad practitioner can jeopardise the whole business."*
 *
 * Our own alert level is NOT here: it is operator policy
 * (`GatewaySettings.disputeRateAlertPct`) and arrives on the `/disputes/rates` response, so
 * hardcoding it would let the screen disagree with the server that computes the alarm.
 */
export const STRIPE_DISPUTE_CLIFF_PCT = 0.75;
